(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Vuex"), require("_"));
	else if(typeof define === 'function' && define.amd)
		define(["Vuex", "_"], factory);
	else if(typeof exports === 'object')
		exports["contractor-management-sm"] = factory(require("Vuex"), require("_"));
	else
		root["contractor-management-sm"] = factory(root["Vuex"], root["_"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__5880__, __WEBPACK_EXTERNAL_MODULE__60bb__) {
return 